import { createContext, useContext } from 'react';
import type { NoticeApi } from './types';

export const NoticeContext = createContext<NoticeApi | null>(null);

/** Показ ошибок и сообщений справа сверху. Требует NoticeProvider выше по дереву. */
export function useNotice(): NoticeApi {
  const api = useContext(NoticeContext);
  if (!api) {
    throw new Error('useNotice используется вне NoticeProvider');
  }
  return api;
}
